import { Overlay, Container, Title, Text } from '@mantine/core';
import classes from './HeroContent.module.css';

function HeroContent(props: any) {
    return (
        <div className={classes.hero}>
            <Overlay
                gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 40%)"
                opacity={1}
                zIndex={0}
            />
            <Container className={classes.container} size="md" py={300}>
                <Title className={classes.title}>IC Trading</Title>
                <Text className={classes.description} size="xl" mt="xl">
                    Personalized approach to oil product wholesale
                </Text>

                {/*<Button variant="gradient" size="xl" radius="sm" gradient={{ from: 'var(--mantine-color-yellow-4) 0%', to: 'var(--mantine-color-orange-9) 100%', deg: -90}} className={classes.control} onClick={() => props.scrollToSection()}>*/}
                {/*    Contact us*/}
                {/*</Button>*/}
            </Container>
        </div>
    );
}

export default HeroContent;